<template>
  <div>
    <VueApexChart  height="215" :options="options" :series="series"></VueApexChart>
  </div>
</template>
<script>
import VueApexChart from 'vue-apexcharts'
import ShotStats from '../../models/ShotStats'
import moment from 'moment'
export default {
  name: 'GreensInRegulationPieChart',
  components: {
    VueApexChart
  },
  props: ['matches', 'player'],
  data() {
    return {
      data: undefined,
      series: undefined,
      options: {
        chart: {
          type: 'radialBar'
        },
        plotOptions: {
          radialBar: {
            hollow: {
              size: '50%'
            },
            dataLabels: {
              name: {
                show: false
              },
              value: {
                show: true,
                fontSize: '22px'
              }
            }
          },

        },
        labels: ["GIRs"],
      }
    }
  },
  mounted () {
    this.data = this.createData()
  },
  methods: {
    createData() {
      var shotStats = new ShotStats(this.matches, this.player)
      var greensInRegulation = shotStats.greensInRegulation
      this.series = [greensInRegulation.last(50)]
    }
  }
}

function getDateList(data) {
  return data.map(obj => {
    return moment(obj.date).format("YYYY-MM-DD")
  })
}

</script>
